import { CalendarItemType } from '$tablet-app/src/app/models';
import * as React from 'react';
import styled from 'styled-components/native';
import { Text } from '../Text/Text';
import { EmojiWithBackgroundProps } from './EmojiWithBackground.props';
import { View } from 'react-native';

export const EmojiWithBackground = (props: EmojiWithBackgroundProps) => (
  <Container
    preset={props.preset || CalendarItemType.Event}
    style={props.style}
  >
    <Emoji style={props.emojiStyle}>{props.emoji}</Emoji>
  </Container>
);

const Container = styled(View)<{ preset: CalendarItemType }>`
  width: 76px;
  height: 76px;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const Emoji = styled(Text)`
  font-size: 40px;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
